'use strict';

module.exports = require('./Autosuggest').default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-autosuggest/dist/index.js
// module id = 1002
// module chunks = 0